export default "__VITE_ASSET__CJMcGltP__"